// @flow
import { all, call } from "redux-saga/effects";
import type { Saga } from "redux-saga";
import watchGetWp from "../../sagas/getWp";

export default function* mainSaga(): Saga<void> {
  yield all([
    call(watchGetWp),
  ]);
}
